import { render, staticRenderFns } from "./TopRenderedContent.vue?vue&type=template&id=1899cc2a&"
import script from "./TopRenderedContent.vue?vue&type=script&lang=js&"
export * from "./TopRenderedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports